import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
// Slides
import { SwiperSlide } from 'swiper/react';

import IBimagehiplock1 from '@/pages/ReportV2/components/Modals/assets/IBimagehiplock1.png';
import IBimagehiplock2 from '@/pages/ReportV2/components/Modals/assets/IBimagehiplock2.png';
// Styles
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

import { VerticalSwiper } from '@/components/swiper';

export const HipLockModalContent = () => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='11' size-lg='6' size-xl='6'>
                <div>
                  <IonImg class={styles.avatar} src={IBimagehiplock1} />
                </div>
              </IonCol>
              <IonCol size='11' size-lg='5' size-xl='5'>
                <div>
                  Towards the end of leg extension the hip of the supporting leg will go into abduction, lifting the
                  free side of the pelvis (swing leg). The pelvis will also rotate slightly forward. This{' '}
                  <i>hip lock</i> is a result of co-contractions (feedforward) of all muscles in the hip area to protect
                  the joint.
                  <br></br>
                  <br></br>
                  Hip abduction will also increase tension in the iliotibial band which is fully stretched by the
                  contraction of the <i>m. gluteus maximus</i>. This in turn results in a lateral force which widens the
                  medial interarticular space of the knee. This force has the opposite effect to gravity, which tries to
                  widen the lateral interarticular space. A proper execution of hip lock results in an equal
                  distribution of forces over the tibia plateau/menisci.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>

        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow class='ion-justify-content-center ion-align-items-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='11' size-lg='6' size-xl='6'>
                <div>
                  <IonImg class={styles.avatar} src={IBimagehiplock2} />
                </div>
              </IonCol>
              <IonCol size='11' size-lg='5' size-xl='5'>
                <div>
                  Without raising the free pelvic side, running economy will be much worse. In case of a hip drop
                  (lowering of the pelvis), endorotation of the supporting leg will become problematic and stability of
                  the knees will be much lower.
                  <br></br>
                  <br></br>
                  Hip drop typically leads to kneeing in, increasing tension on all kinds of tissues.
                  <br></br>
                  <br></br>
                  The lack of tension in the iliotibial band will widen the lateral interarticular space, putting much
                  stress on the medial meniscus.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
